import classnames from "classnames";
import { noop } from "lodash";
import { useFormContext } from "react-hook-form";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";

interface StaticOptionItemProps {
  optionIndex: number;
  questionIndex: number;
  questionType: "single_choice" | "multiple_choice";
}
export const StaticOptionItem = ({
  questionIndex,
  optionIndex,
  questionType,
}: StaticOptionItemProps) => {
  const { watch } = useFormContext();
  const option = watch(
    `quiz[questions][${questionIndex}].options[${optionIndex}]`,
  );
  if (option._destroy) return null;

  return (
    <div className="mt-4 flex items-center">
      <Form.Item hideLabel hideDescription hideBorder className="!mr-1 !p-0">
        <Form.Checkbox
          checked={option.correct}
          name={questionType}
          isRoundedFull={questionType === "single_choice"}
          className="!mt-0"
          inputClassName={classnames(
            "disabled:!bg-toggle-inactive disabled:!border-transparent focus:!outline-none",
            {
              "hover:!bg-primary focus:!bg-primary": !option.correct,
              "hover:!bg-toggle-inactive focus:!bg-toggle-inactive":
                option.correct,
            },
          )}
          onChange={noop}
          disabled={option.correct}
        />
      </Form.Item>
      <div className="!grow !p-0">
        <Typography.BodyMd>{option.value}</Typography.BodyMd>
      </div>
    </div>
  );
};
